<div class="video-ad-container d-none" [id]="adContainerId" #adContainerElement>
  <div class="ad-countdown-overlay">
    <div class="ad-countdown-text" role="timer" aria-live="polite">
      Ad break<span class="ad-timer" *ngIf="displayTimer$ | async as displayTimer"> - {{ displayTimer | floTime }} left</span>
    </div>
  </div>
</div>
<flo-video-error
  class="video-ad-container d-none justify-content-center align-items-center flex-column position-absolute top left right bottom"
  title="Commercial Break"
>
  <p *ngIf="adTimer$ | async as adTimer"
    >Your event will resume in {{ adTimer | floTime }}</p
  >
</flo-video-error>
